import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { deleteIPSDataTracker, post, } from '../../api';

import IpsDTProjectGrid from '../../components/ProjectsGrid/IpsDTProjectGrid';

import IpsDTProjectList from 'components/ProjectsList/IpsDTProjectList';
import IPSDTViewType from 'components/ViewType/IPSDTViewType';
import ConfirmDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/ConfirmDialogBox';
import Button from 'components/Button';
import { isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';
import { directToProject } from '../../utils/Dashboard';
import SpinnerNew from "../../components/Spinner/SpinnerNew";

export default withRouter(function DataTrackerProgress(props) {
  const { context, history, cardview, onViewTypeChange, projectList } = props;
  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});
  let tab = history.location.pathname.split('/')[2]

  useEffect(() => {
    getProjects();
  }, []);

  async function getProjects() {
    
      //spinnerOn();
      setIsLoading(true);

      const result = await post(`ipsprojects`, '', {});

      setProjects(result?.data?.filter(everyProject => everyProject.trackerStatus === 'DT_A'));
      // setProjects(result.data);
      //spinnerOff();
      setIsLoading(false);
    
  }
  function goToProject(project) {
    


    directToProject(project,history,'datatracker_progress',context)
  }
  function handleButtonClick(project) {
    history.push(`/ipsdatatracker/newproject`);
    context.setProjectTab('datatracker_progress');

  }

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function handleDeleteBtnClick(project) {
    setConfirmDialogDetails({
      title: `Do you want to Delete ${project.stationName}?`,
      handleCancel: handleCancel,
      submitFunctionArgs: project,
      handleSubmit: deleteDataTracker,
      confirmButtonName: 'Yes,Delete'
    })
    setIsModalOpen(true)
  }
  async function deleteDataTracker(project) {
    await deleteIPSDataTracker(project)
    getProjects()
    setIsModalOpen(false)
  }
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <SpinnerNew display={isLoading}/>
        {isIPSDataCreatorOrAdministrator() &&
          <Button id="add-new-dt-btn" onClickHandler={handleButtonClick} >Add New Data Tracker</Button>
        }
        <div style={{ flexGrow: 1 }} />
        <IPSDTViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'DT_A'}
          dtstatus={'DT_A'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsDTProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={goToProject}
          isLoading={isLoading}
          handleDeleteBtnClick={handleDeleteBtnClick}
          {...props}
        />
      ) : (
        <IpsDTProjectList
          projects={projectList(projects)}
          onButtonClick={goToProject}
          {...props}
          tabView={tab}
        />
      )}
      <ConfirmDialog
        show={isModalOpen}
        title={confirmDialogDetails.title}
        handleCancel={confirmDialogDetails.handleCancel}
        submitFunctionArgs={confirmDialogDetails.submitFunctionArgs}
        handleSubmit={confirmDialogDetails.handleSubmit}
        confirmButtonName={confirmDialogDetails.confirmButtonName}
        cancelButtonName={'No,Cancel'}
      />

    </Fragment>
  );
});